export const PI = 3.14159;
export const WEEK_AVERAGE = '4.348';

